define('controllers/contact',['require','nicEditlatest','utils','layout'],function (require) {
    'use strict';
    require('nicEditlatest');
    var utils = require('utils');
    var layout = require('layout'); 
    return {
        load: function (hashQuerystring, data, state) {
            function init() {

                var emailform = $('#emailform'),
                    buttons = $('button', emailform),
                    submitButton = $('#send', emailform),
                    message = $('#message'),
                    emailBox = $('[name="Email"]', emailform),
                    subjectBox = $('[name="Subject"]', emailform),
                    bodyId = 'emailBody',
                    bodyEditor = new window.nicEditor({ fullPanel: true, maxHeight: 400 }).panelInstance(bodyId, { hasPanel: true }),
                    submitButtonEmptyEmail = $('#sendWithEmptyEmail'),
                    sendWithEmptyEmailContainer = $('#sendWithEmptyEmailContainer'),
                    success = $('#success');

                function validate(data) {
                    var errors = [];
                    for (var field in data) {
                        if (data.hasOwnProperty(field)) {
                            if (field !== 'Email' && data[field].trim() === '') {
                                errors.push('Please enter a value for {0}.'.format(field));
                            }
                        }
                    }
                    errors.length > 0 ? window.Utilities.setError(errors.join('<br/>'), message) : message.hide(); // jshint ignore:line
                    return errors.length === 0;
                }

                //clear body box
                bodyEditor.instanceById(bodyId).setContent('');

                //set to
                var to = utils.querystring('to', hashQuerystring);
                var toEmail = to === '' ? window.ServerData.Emails.MemberSupport : to;
                var forwardedQS = hashQuerystring.replace(/&?to=[^&]*/g, ''); //remove 'to', but pass the rest. Test: https://regex101.com/r/fW5oK8/1
                var mailTo = 'mailto:{0}{1}'.format(toEmail, forwardedQS);
                $('#to').attr('href', mailTo).text(toEmail);

                //set email
                emailBox.val(utils.tryGetValue(window.ServerData, 'user.Email'));
                $('[name="Subject"]', emailform).val(utils.querystring('subject', hashQuerystring));

                function sendEmail() {
                    var data = {
                        ToEmail: toEmail,
                        Email: emailBox.val(),
                        Subject: subjectBox.val(),
                        Body: bodyEditor.instanceById(bodyId).getContent()
                    };
                    if (validate(data)) {
                        buttons.prop('disabled', true);
                        $.post('/api/contact/send', data).then(function (response) {
                            window.Utilities.handleAJAXResponse(response, function (obj) {
                                window.Utilities.setInfo('Your message was sent successfully! We will get back to you ASAP!', message);
                                submitButton.show();
                                sendWithEmptyEmailContainer.hide();
                                emailform.hide();
                                success.show();
                            }, function (err) {
                                window.Utilities.setError(err, message);
                            });
                            buttons.prop('disabled', false);
                        }, function (err) {
                            window.Utilities.setError('An error occurred while sending the email. Please try again later.', message);
                            buttons.prop('disabled', false);
                        });
                    }
                }
                
                submitButton.on('click', function () {
                    var emptyEmail = emailBox.val().trim() === '';
                    if (emptyEmail) {
                        submitButton.hide();
                        sendWithEmptyEmailContainer.show();
                    } else {
                        sendEmail();
                    }
                });

                $('#fillInEmail').on('click', function () {
                    submitButton.show();
                    sendWithEmptyEmailContainer.hide();
                    emailBox.focus();
                });

                submitButtonEmptyEmail.on('click', sendEmail);

                window.Utilities.setDefaultButton(emailform, submitButton);
                emailBox.focus();

                layout.initGlobalHandlers(); //placeholder
            }

            return layout.initStatic('/fe/templates/about/contact')
                  .then(init);
        },
        unload: function() {
            $('#fillInEmail').off('click');
            $('#sendWithEmptyEmail').off('click');
            var emailform = $('#emailform');
            window.Utilities.unSetDefaultButton(emailform);
            $('#send', emailform).off('click');
        }
    };
});
